// extracted by mini-css-extract-plugin
export default {"root":"TermsAndConditionsArtistPage_root__uMDMN","content":"TermsAndConditionsArtistPage_content__LvMgT"};